import {
    LINK_DESTINATION_CODE_REQUEST,
    LINK_DESTINATION_CODE_SUCCESS,
    LINK_DESTINATION_CODE_ERROR
  } from "./LinkDestinationCodeTypes";
  
  const initialState = {
    loading: false,
    error: "",
    linkDestinationCodes: []
  };
  
  export default (state = initialState, action) => {
    switch (action.type) {
      case LINK_DESTINATION_CODE_REQUEST:
        return {
          ...state,
          loading: true
        };
      case LINK_DESTINATION_CODE_SUCCESS:
        // do something
        return {
          ...state,
          loading: false,
          linkDestinationCodes: action.payload,
          error: ""
        };
      case LINK_DESTINATION_CODE_ERROR:
        return {
          ...state,
          loading: false,
          linkDestinationCodes: [],
          error: action.payload
        };
      default:
        return state;
    }
  };
  